import { AxiosResponse } from "axios";
import { getAuthToken } from "../utils/commonHelper";
import axiosInstance from "../utils/AxiosInstance";

const API_URL = `${process.env.REACT_APP_API_URL}/admin-auth`;

const customHeaders = {
  "content-type": "application/json",
};

export const fetchStaffTable = async ({
  page,
  limit,
}: {
  page: number;
  limit: number;
}): Promise<AxiosResponse> => {
  const response = await axiosInstance.get(
    `${API_URL}/admin-table?page=${page}&limit=${limit}`,
    {
      headers: {
        ...customHeaders,
        Authorization: `Bearer ${getAuthToken()}`,
      },
    }
  );
  return response;
};

export const createStaffService = async (data: any): Promise<AxiosResponse> => {
  const response = await axiosInstance.post(`${API_URL}/admin-register`, data, {
    headers: {
      ...customHeaders,
      Authorization: `Bearer ${getAuthToken()}`,
    },
  });
  return response;
};

export const updateStaffService = async ({
  id,
  data,
}: {
  id: string;
  data: any;
}): Promise<AxiosResponse> => {
  const response = await axiosInstance.put(
    `${API_URL}/admin-update/${id}`,
    data,
    {
      headers: {
        ...customHeaders,
        Authorization: `Bearer ${getAuthToken()}`,
      },
    }
  );
  return response;
};

export const deleteStaffService = async ({
  id,
}: {
  id: string;
}): Promise<AxiosResponse> => {
  const response = await axiosInstance.delete(`${API_URL}/admin-delete/${id}`, {
    headers: {
      ...customHeaders,
      Authorization: `Bearer ${getAuthToken()}`,
    },
  });
  return response;
};